// Microsoft Clarity — session recording + heatmaps.
//
// Unlike the Meta Pixel, this is NOT deferred to the first interaction: Clarity
// has to be alive from the first frame or it misses the initial scroll and
// clicks, which is exactly what we want to measure. The tag itself is `async`,
// so it never blocks rendering.

const CLARITY_PROJECT_ID = 'xxua1haazx'

let injected = false

/** Injects the official Clarity tag once. Safe to call more than once. */
export function initClarity(): void {
  if (injected) return
  injected = true

  try {
    if (typeof window === 'undefined' || typeof document === 'undefined') return

    const w = window as any

    // Standard Clarity queue stub: calls made before the script lands are
    // buffered and replayed once it loads.
    w.clarity =
      w.clarity ||
      function (...args: unknown[]) {
        ;(w.clarity.q = w.clarity.q || []).push(args)
      }

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`

    const first = document.getElementsByTagName('script')[0]
    if (first && first.parentNode) {
      first.parentNode.insertBefore(script, first)
    } else {
      document.head.appendChild(script)
    }
  } catch {
    // An adblocker or a locked-down environment must never break the page.
  }
}
